// Client hydration entry point. Per TanStack Start latest docs:
// https://tanstack.com/start/latest/docs/framework/react/guide/client-entry-point
//
// StartClient self-locates the router via getRouter from router.tsx; no
// router prop is passed.

import { StartClient } from '@tanstack/react-start/client'
import { StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'

hydrateRoot(
  document,
  <StrictMode>
    <StartClient />
  </StrictMode>,
)
